import { prop } from 'datx';
import { inject } from 'dependable-react';
import { first } from 'lodash';
import { computed } from 'mobx';

import { Gender } from '../../enums/Gender';
import { I18N_TOKEN } from '../../services/InjectTokens';
import { AppData } from '../AppData';
import { BaseModel } from './BaseModel';

interface IOptions {
  gender: Gender;
  uid: string;
}

export class Banner extends BaseModel {
  @computed
  private get activeOption() {
    const mainAvatar = this.meta.collection && (this.meta.collection as AppData).mainAvatar;
    const firstOption = first(this.options) as IOptions;

    if (mainAvatar) {
      return this.options.find((option) => option.gender === mainAvatar.gender) || firstOption;
    }

    return firstOption;
  }

  @computed
  public get isBoy() {
    return this.activeOption.gender === Gender.MALE;
  }

  @computed
  public get message() {
    return this.i18n.t(this.activeOption.uid);
  }

  public static type = 'banner';

  @prop
  public id!: number;

  @prop
  public showBannerIcon!: boolean;

  private i18n = inject(I18N_TOKEN);

  @prop
  private options!: Array<IOptions>;
}
